module.exports = __webpack_public_path__ + "static/media/schedule-gif.ff53eaec.gif";